import { createApp, mixin } from 'vue'
import { createRouter } from 'vue-router'

import { createI18n } from 'vue-i18n'

import { store } from '@/store'
import { router } from './router'

import Local from '@/plugins/Local'
import Device from '@/plugins/Device'
import Hub from '@/plugins/Hub'
import Offset from '@/plugins/Offset'
import Dom3d from '@/plugins/Dom3d'
import { emitter } from '@/utils/emitter'

import messages from '@/locales'

import AppImage from '@/components/common/AppImage'

import extendedComponent from '@/mixins/extendedComponent'

import App from './App.vue'

class VueArtwork {
  constructor () {
    this.app = createApp(App)

    // router
    this.router = createRouter(router)
    this.app.use(this.router)

    // i18n
    this.i18n = createI18n({
      locale: 'en',
      messages
    })
    this.app.use(this.i18n)

    // VueX
    this.app.use(store)

    // Mixin
    this.app.mixin(extendedComponent)

    // Handmade Plugins
    this.app.use(Local)
    this.app.use(Device)
    this.app.use(Hub)
    this.app.use(Offset)
    this.app.use(Dom3d)

    this.app.component('app-image', AppImage)

    this.app.mount('#app')

    this.router.beforeEach(this.beforeGuard)
  }

  beforeGuard (to, from, next) {
    // // first loading
    // if (!from.name) {
    //   // debug
    //   if (to.query.debug || to.name === 'Homepage') {
    //     next()
    //     return
    //   }
    //   // redirect to homepage
    //   else {
    //     next({name: 'Homepage'})
    //     return
    //   }
    // }

    // no transition screen for keypoint
    if ((to.name === 'Keypoint' || from.name === 'Keypoint') && from.params.level === to.params.level) {
      // from.params.level === to.params.level
      // is to ignore the case when you are in keypoint and use menu to go to another level
      next()
      return
    }

    emitter.emit('transition:on')
    // generic case | no level remove transition by itself when loaded
    if (to.name !== 'Level') {
      setTimeout(() => {
        next()
        emitter.emit('transition:off')
      }, 1000)
      return
    }
    else {
      // level transition
      setTimeout(next, 1000)
      return
    }

    next()
    return
  }
}

new VueArtwork()
